import React, { useEffect, useState } from "react";

// Semantic UI React
import { Radio, List } from "semantic-ui-react";

// Import Esri Components
import TileLayer from "@arcgis/core/layers/TileLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";

const BasemapWidget = ({ view, basemaps, localConfig, setLocalConfig }) => {
  const [active, setActive] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    // console.log("BasemapWidget", { basemaps, localConfig });

    setSelected(
      basemaps.filter((basemap) => localConfig.basemap === basemap.id)[0]
    );
  }, []);

  //   console.error("BasemapWidget", { view, basemaps, active });

  // Removes the current basemap (if set)
  // Creates a new basemap layer at the same index
  useEffect(() => {
    if (selected) {
      const args = {
        url: selected.url,
        id: selected.name.replace(/\s+/g, "-").toLowerCase(),
        title: selected.name,
        index: 0,
        minScale: 409600,
        maxScale: 200,
        print: true,
        basemap: true,
        legendEnabled: false,
        basemap_id: selected.id,
      };

      const obj = selected.tiled
        ? new TileLayer(args)
        : new MapImageLayer(args);

      // if there is a basemap set then remove it
      if (active) {
        view.map.layers.remove(active);
      }

      // Add the new basemap and set it as the first layer
      view.map.layers.unshift(obj);

      // set the active basemap layer
      setActive(obj);

      // Update the localConfig

      var new_config = { ...localConfig };
      new_config.basemap = selected.id;

      setLocalConfig(new_config);
    }
  }, [selected]);

  if (!active) {
    return null;
  }

  return (
    <List style={{ padding: "0 .5em" }}>
      {basemaps
        .sort((a, b) =>
          a.render_order > b.render_order
            ? 1
            : b.render_order > a.render_order
            ? -1
            : 0
        )
        .map((basemap) => {
          return (
            <List.Item key={basemap.id} style={{ paddingBottom: ".5em" }}>
              <Radio
                style={{ width: "100%" }}
                label={basemap.name}
                name="basemap"
                checked={active.basemap_id === basemap.id}
                onClick={() => setSelected(basemap)}
              />
            </List.Item>
          );
        })}
    </List>
  );
};

export default BasemapWidget;
